import { call, put, takeLatest } from 'redux-saga/effects';
import { REQUEST_LINK, RESET } from './constants';
import { done, failed, sending } from './actions';
import { forgotPassword, resetPassword } from '../services/password';
import { errorMessage } from '../Errors';

function* send(request, payload) {
  yield put(sending());
  try {
    const { message } = yield call(request, payload);
    yield put(done(message));
  } catch (error) {
    // The server says what's wrong ("That reset link has expired…"); shown on the form, not as an app error.
    yield put(failed(errorMessage(error)));
  }
}

function* requestLinkTask(action) {
  yield call(send, forgotPassword, action.payload);
}

function* resetTask(action) {
  yield call(send, resetPassword, action.payload);
}

function* requestLinkWatcher() {
  yield takeLatest(REQUEST_LINK, requestLinkTask);
}

function* resetWatcher() {
  yield takeLatest(RESET, resetTask);
}

const passwordResetSagas = [requestLinkWatcher, resetWatcher];

export default passwordResetSagas;
